var generateStyle = function generateStyle(componentTheme) {
  return {
    instructionsEditWrapper: {
      position: 'relative',
      width: '100%',
      minHeight: '4rem',
      boxSizing: 'border-box',
      padding: componentTheme.instructionsEditWrapperPadding,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    footer: {
      marginTop: componentTheme.footerTopMargin,
      display: 'flex',
      justifyContent: 'flex-end'
    }
  };
};
export default generateStyle;